import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'

@inject('localizationStore')

@observer
export default class ConfirmEmailSuccessPage extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        let ls = this.props.localizationStore!

        return (
            <div>
                <p className="staticInfo">{ls.t!('ConfirmEmailSuccessPage')}</p>
                <Link className="w-100 btn btn-success" to="/login">{ls.t!('LoginBtn')}</Link>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/ConfirmEmailSuccessPage.tsx